/* TODO step and minus */
var multiRange = function (el) {
	var rangeTags = el.querySelectorAll('input');
	var min = parseFloat(rangeTags[0].getAttribute('min'));
	var max = parseFloat(rangeTags[0].getAttribute('max'));
	var rangeWidth = max - min;
    var clickEventName = window.PointerEvent ? 'pointerup' : 'click';
	var addHints = function(){
        var template = el.querySelector('[data-multiRange-hint]');
        if(!template) return false;
        var hintTag = template.content.firstElementChild;
        rangeTags.forEach(function(tag){
            tag.hintTag = tag.insertAdjacentElement('afterEnd', document.importNode(hintTag, true));
            updateHint(tag);
        });
    };
	var moveNearestThumb = function(e){
	    /* событие клика по треку может срабатывать  после того, как подвигал ползунок, нам это не нужно */
	    if(e.target !== el) return;
        console.log('pointer events');

        var clickValue = Math.round(e.offsetX/el.getBoundingClientRect().width*rangeWidth) + min; /* TODO */
		var nearest = rangeWidth;
		var nearestTag;
		rangeTags.forEach(function(tag){
			var offset =  Math.abs(tag.value - clickValue);
			if(offset < nearest){
                nearest = offset;
                nearestTag = tag;
			}
		});
        nearestTag.value = clickValue;
        updateHint(nearestTag);
        updateSelected();
    };

	var updateHint = function(tag){
	    if(!tag.hintTag) return;
	    const ratio = (tag.value-min)/rangeWidth;
        tag.hintTag.innerHTML = tag.value;
        const hintOffset = tag.hintTag.getBoundingClientRect().width*ratio;
        tag.hintTag.style.cssText = 'left:' + ratio*100 + '%; margin-left:-' + hintOffset + 'px';
    };

    var updateSelected = function(){
        var minVal = parseFloat(rangeTags[0].value);
        var maxVal = parseFloat(rangeTags[1].value);
        if(minVal > maxVal) minVal = [maxVal, maxVal=minVal][0];

        el.style.cssText = '--multiRange-low:' + (minVal - min)/rangeWidth*100 + '%; --multiRange-high:' + (maxVal - min)/rangeWidth*100 + '%';
    };

	var onChange = function(e){
        updateHint(e.target);
        updateSelected();
    };

	//
    addHints();
    updateSelected();
    rangeTags.forEach(function(tag){
        tag.addEventListener('input', onChange);
        tag.addEventListener('change', onChange);
    });

    el.addEventListener(clickEventName, moveNearestThumb);
};

export {multiRange};